import {Controller} from "@hotwired/stimulus"
import {resetValues} from "../../../website/javascript/utils/html";

/**
 * This class is not intended to be used directly. You should inherit from it.
 */
export const Question1Base = class extends Controller {
  static targets = ["question1"];

  question1TargetConnected(target) {
    this.showProductLot(target);
    this.showAvailableAtRetailers(target);
  }

  /** BEGIN: Frontend validations */

  showProductLot(target) {
    const productLots = target.querySelectorAll('.js-product-lot');
    const singleProducts = target.querySelectorAll('.js-product-single');
    const productLotInputs = target.querySelectorAll('input[name*="product_lot"]');
    const updateVisibility = () => {
      const selected = target.querySelector('input[name*="product_lot"]:checked')?.value;

      productLots.forEach((lot) => {
        if (selected === "true") {
          lot.classList.remove("d-none");
          lot.querySelectorAll('input').forEach((input) => input.disabled = false)
        } else {
          resetValues(lot);
          lot.classList.add("d-none");
          lot.querySelectorAll('input').forEach((input) => input.disabled = true)
          lot.dispatchEvent(new Event('change'));
        }
      });

      singleProducts.forEach((single) => {
        if (selected === "true") {
          resetValues(single);
          single.classList.add("d-none");
          single.querySelectorAll('input').forEach((input) => input.disabled = true)
        } else {
          single.classList.remove("d-none");
          single.querySelectorAll('input').forEach((input) => input.disabled = false)
          single.dispatchEvent(new Event('change'));
        }
      });
    }

    productLotInputs.forEach((r) => r.addEventListener('change', updateVisibility));

    updateVisibility();
  }
  showAvailableAtRetailers(target) {
    const withoutRetailers = target.querySelectorAll('.js-without-retailers');
    const withRetailers = target.querySelectorAll('.js-with-retailers');
    const note = target.querySelector('.note');
    const availableAtRetailersInputs = target.querySelectorAll('input[name*="available_at_retailers"]');

    const updateVisibility = () => {
      const selected = target.querySelector('input[name*="available_at_retailers"]:checked')?.value;

      if (selected === "true") {
        withoutRetailers.forEach((r) => r.classList.add("d-none"));
        withRetailers.forEach((r) => r.classList.remove("d-none"));
        note.innerHTML = target.dataset.noteWithRetailers

      } else {
        withoutRetailers.forEach((r) => r.classList.remove("d-none"));
        withRetailers.forEach((r) => r.classList.add("d-none"));
        note.innerHTML = target.dataset.noteWithoutRetailers
      }

    }

    availableAtRetailersInputs.forEach((r) => r.addEventListener('change', updateVisibility));

    updateVisibility();
  }

  /** END: Frontend validations */
}

// For index.js auto-generated compilation
export default Controller;
